//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.CornerTypeBuilder.js";
import "../no/SelectNXObject.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"RadiusFromBendTable",1,0],[0,"ReverseValue",1,0],[1,"RouteAssignCornerCornerBlock",0,"Routing.CornerTypeBuilder",0],[1,"RouteAssignCornerEndObject",0,"SelectNXObject",0],[1,"RouteAssignCornerRouteSelection",0,"Routing.RouteObjectCollector",0],[1,"RouteAssignCornerStartObject",0,"SelectNXObject",0],[1,"SelectCopeStock",0,"SelectNXObjectList",0],[1,"UBendSelection",0,"Routing.RouteObjectCollector",0]],[[["stockObjects"],"SetStockList",{},1,0],[[],"GetBendCornerAttributes",{R_:{selectedRowAttributesCharxList:"Routing.CharacteristicList"}},0,0],[["selectedRowAttributesCharxList"],"SetBendCornerAttributes",{},1,0],[[],"GetAttributeHolder",{R_:{attributeHolder:"NXObject"}},0,0]],[]];
SPLM.Routing.AssignCornerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.AssignCornerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;